/**
 * Experience Spot Icon Component
 * 
 * Clean, professional clickable indicator for each experience spot
 */

import React from 'react';
import { ExperienceSpot } from '../../types/experienceMode.types';

interface ExperienceSpotIconProps {
  spot: ExperienceSpot;
  index: number;
  onClick: () => void;
  isVisited: boolean;
}

export const ExperienceSpotIcon: React.FC<ExperienceSpotIconProps> = ({
  spot,
  index,
  onClick,
  isVisited,
}) => {
  // Don't render if no position is set
  if (!spot.iconPosition) {
    return null;
  }

  const hasDescription = spot.description && spot.description.trim().length > 0;

  return (
    <button
      className={`experience-spot ${isVisited ? 'visited' : ''}`}
      style={{
        top: spot.iconPosition.top,
        left: spot.iconPosition.left,
        animationDelay: `${index * 100}ms`,
      }}
      onClick={onClick}
      aria-label={`Watch video: ${spot.title}${hasDescription ? ` — ${spot.description}` : ''}`}
    >
      <div className="spot-indicator">
        <span className="spot-number">{spot.displayNumber}</span>
        {isVisited && <span className="spot-check">✓</span>}
      </div>
      <div className="spot-text">
        <span className="spot-label">{spot.title}</span>
        {hasDescription && (
          <span className="spot-description">{spot.description}</span>
        )}
      </div>
    </button>
  );
};
